import { C09AZIndexProps } from './C09AZIndex.types';
import { AlphaLinksIndexProps, LinksDictionaryType } from '@ahc-digital/component-library';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetAZIndexModel(props?: C09AZIndexProps): AlphaLinksIndexProps {
  const { params, fields } = props || {};
  const azIndexFieldData = fields?.data?.azIndex;

  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  const linkItemFolder = {} as LinksDictionaryType;
  const azIndexItems = azIndexFieldData?.azIndexItems?.results;

  if (azIndexItems?.length) {
    for (const azIndexItem of azIndexItems) {
      const letter = azIndexItem?.letter?.jsonValue?.value;
      const links = azIndexItem?.links?.jsonValue?.value;

      if (!letter || !links?.length) {
        continue;
      }

      linkItemFolder[letter] = links.map((linkFieldValue: LinkFieldValue) => {
        return renderLink({ value: linkFieldValue });
      });
    }
  }

  return {
    backgroundColor: getDroplink(params?.BackgroundColor, 'whiteSmoke'),
    contentAlignment: getDroplink(params?.ContentAlignment, 'center'),
    headline: renderText(azIndexFieldData?.headline?.jsonValue),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    supportCopy: renderRichText(azIndexFieldData?.supportCopy?.jsonValue),
    supportCopyBottom: renderRichText(azIndexFieldData?.supportCopyBottom?.jsonValue),
    linkItemFolder,
  };
}
